"use client";
import ModalComponent from "./Modal";
import PaperComponent from "./Paper";
import ButtonComponent from "./Button";
import React, { useCallback, useEffect } from "react";
import { IMAGES, WEB_COLORS } from "@/lib/constants";
import { useGetIfscBankListQuery } from "@/lib/redux";
import { Autocomplete, Stack, TextField, Typography } from "@mui/material";
import { useTranslations } from "next-intl";
import DrawerComponent from "./Drawer";

const BankMandateModal = ({
  formik,
  open,
  bankName,
  handleModal,
  selectedBankDetails,
  handleSelectedBank,
}) => {
  const t = useTranslations("BankMandateModal");
  const { data: banksList, refetch, isSuccess } = useGetIfscBankListQuery();

  const otherBanks = banksList?.data?.map(({ key, logo_url }, index) => {
    return (
      <PaperComponent
        onClick={() => {
          handleSelectedBank({
            ...selectedBankDetails,
            bankName: banksList?.data[index].key,
          });
          handleModal(false);
          formik.setFieldValue("bankName", key);
        }}
        key={key}
        sx={{
          border: `1px solid #fff`,
          p: 4,
          "&:hover": {
            cursor: "pointer",
            border: `1px solid ${WEB_COLORS.primary}`,
          },
        }}
      >
        <Stack alignItems={"center"} direction={"row"} rowGap={1}>
          <Typography align="center" sx={{ textTransform: "capitalize" }}>
            {key}
          </Typography>
        </Stack>
      </PaperComponent>
    );
    //   }
  });

  useEffect(() => {
    if (isSuccess && bankName === null) {
      handleModal(true);
    }
  }, [banksList]);


  const handleDrawer = useCallback(() => {
    handleModal(false);
  }, [handleModal]);

  return (
    <DrawerComponent
      title={t("tittle")}
      fullWidth
      maxWidth="lg"
      open={open}
      handleDrawer={handleDrawer}
    >
      {banksList?.data ? (
        <Stack my={2} rowGap={2}>
          <Autocomplete
            options={banksList?.data}
            getOptionLabel={(option) => option.key}
            renderInput={(params) => (
              <TextField
                {...params}
                label={t("selectbankname")}
                variant="outlined"
              />
            )}
            onChange={(event, newValue) => {
              handleSelectedBank({
                ...selectedBankDetails,
                bankName: newValue?.key,
              });
              formik.setFieldValue("bankName", newValue?.key);
              handleModal(false);
            }}
          />
          <Typography>{t("allbanks")}</Typography>
          {otherBanks}
        </Stack>
      ) : (
        <Stack>
          <ButtonComponent onClick={() => refetch()}>
            Fetch Bank Data
          </ButtonComponent>
        </Stack>
      )}
    </DrawerComponent>
  );
};

export default BankMandateModal;
